import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'ed-switch'
})
class EdSwitch extends Vue {

    @Prop({}) readonly label: string;
    @Prop({ default: false }) readonly value!: boolean;
    @Prop({ default: false }) readonly disabled!: boolean;

    public checked: boolean = false;
    canEmit: boolean = true;

    onChange(event: Event): void {
        const target = event.target as HTMLInputElement;
        if (this.$listeners.click) {
            target.checked = !target.checked;
            this.$emit('click', this.checked);
            return;
        }
        this.checked = target.checked;
    }

    onInput(event: Event): void {
        const target = event.target as HTMLInputElement;
        this.checked = target.checked;
        this.$emit('input', this.checked);
    }

    @Watch('checked')
    checkedChanged() {
        this.$emit('update:checked', this.checked);
        this.$emit('change', this.checked);
    }

    @Watch('value')
    onValueChanged(newValue: boolean) {
        this.checked = newValue; 
    }

    mounted() {
        this.checked = this.value;
    }
}

export default Vue.component('ed-switch', EdSwitch);
